<template>
	<div>
		<el-table :data="
        lists.filter(
          (data) =>
            !search || data.openid.toLowerCase().includes(search.toLowerCase())
        )
      " style="width: 100%">
			<el-table-column label="id" prop="id" width="80px"> </el-table-column>
			<el-table-column label="标题" prop="title"> </el-table-column>

			<el-table-column width="150" label="时间" prop="time" :formatter="dateForma">
			</el-table-column>
			<el-table-column label="状态" width="80" prop="state" :formatter="dateState">
			</el-table-column>
			<el-table-column align="right" width="180" >
				<template slot="header" slot-scope="scope">
					<el-input v-model="search" size="mini" placeholder="输入关键字搜索?" />
				</template>
				<template slot-scope="scope">
					<el-button icon="el-icon-edit" size="mini" @click="handleSel(0,scope.$index, scope.row)">修改
					</el-button>
					<el-button icon="el-icon-view" size="mini" type="danger"
						@click="seeSel(0,scope.$index, scope.row)">查看
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<div class="row">
			<div class="col-6" style="padding-top: 20px">
				<el-button icon="el-icon-circle-plus" size="mini" type="danger" @click="handleSel(1,1,1)">添加
				</el-button>
			</div>
			<div class="col-6" style="text-align: right; padding-top: 20px">
				<el-pagination @current-change="handleSizeChange" background layout="prev, pager, next" :total="count">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="`ID：${ruleForm.id}`" :visible.sync="dialogVisible" width="900px" :before-close="handleClose">
			<div style="overflow: auto;height: 40rem;width: 100%;">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" style="margin-right: 1.5rem;" class="demo-ruleForm">
					<el-form-item label="主标题" prop="title">
						<el-input v-model="ruleForm.title"></el-input>
					</el-form-item>

					<el-form-item label="副标题" prop="describe">
						<el-input v-model="ruleForm.describe"></el-input>
					</el-form-item>

					<el-form-item label="图片大" prop="imgages_a">
						<el-input v-model="ruleForm.imgages_a"></el-input>
						<el-link type="primary">
							<upload @upFile="imgages_a" />
						</el-link>
					</el-form-item>

					<el-form-item label="图片小" prop="imgages_b">
						<el-input v-model="ruleForm.imgages_b"></el-input>
						<el-link type="primary">
							<upload @upFile="imgages_b" />
						</el-link>
					</el-form-item>

					<el-form-item label="链接地址" prop="describe">
						<el-input v-model="ruleForm.connect"></el-input>
					</el-form-item>

					<el-form-item label="详细内容" prop="detailed">
						<el-input type="textarea" rows="4" v-model="ruleForm.detailed"></el-input>
					</el-form-item>

					<el-form-item label="数据状态" prop="state">
						<el-select v-model="ruleForm.state" placeholder="设置数据状态">
							<el-option v-for="item in options" :key="item.value" :value="item.value"
								:label="item.label">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose('ruleForm')">取 消</el-button>
				<el-button v-if="odb.handleKEY==1" type="primary" @click="handleAdd('ruleForm')">添 加</el-button>
				<el-button v-if="odb.handleKEY==0" type="primary" @click="handleEdit('ruleForm')">保 存</el-button>
			</span>
		</el-dialog>
		
		
		<el-dialog :title="`ID：${ruleForm.id}`" :visible.sync="seeVisible" width="900px" :before-close="seeClose">
			<div style="overflow: auto;height: 40rem;width: 100%;">
				<div v-for="(value, name) in ruleForm" style="line-height: 30px;">
						{{ name }}: {{ value }}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="seeClose('ruleForm')">取 消</el-button>
			</span>
		</el-dialog>
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				odb: {
					//
					handleKEY: 0,
				},
				type_id: 0, //栏目id
				options: [{
						value: 0,
						label: "待设置",
					},
					{
						value: 1,
						label: "正常",
					},
					{
						value: 2,
						label: "异常",
					},
					{
						value: 3,
						label: "冻结",
					},
				],

				Logistics: [{
						value: 0,
						label: "未设置",
					},
					{
						value: 1,
						label: "收藏",
					},
					{
						value: 2,
						label: "待付款",
					},
					{
						value: 3,
						label: "已付款",
					},
					{
						value: 4,
						label: "待发货",
					},
					{
						value: 5,
						label: "已发货",
					},
					{
						value: 6,
						label: "运输中",
					},
					{
						value: 7,
						label: "已签收",
					},
				],
				ruleForm: {
					id: 0,
					state: 0, //数据状态
					username: "", //用户姓名
					telephone: "", //用户手机
					address: "", //用户地址

					title: "", //标题
					describe: "", //副标题
					imgages_a: "", //图片大
					imgages_b: "", //图片小
					detailed: "", //详细内容
					connect: "", //链接地址
				},
				rules: {
					title: [{
							required: true,
							message: '请输入活动名称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],
				},
				dialogVisible: false,
				seeVisible: false,
				lists: [{}],
				search: "",
				count: 0,
			};
		},
		methods: {
			imgages_a(path) {
				//这个就是你要的path
				this.$set(this.ruleForm, 'imgages_a', path)
			},
			imgages_b(path) {
				//这个就是你要的path
				this.$set(this.ruleForm, 'imgages_b', path)
			},
			handleClose(done) {
				//this.$refs[formName].resetFields();
				this.dialogVisible = false;
				// this.$confirm('确认关闭？')
				// 	.then(_ => {
				// 		done();
				// 	})
				// 	.catch(_ => {});
			},
			//添加
			handleAdd(formName) {
				var formVerification = true;
				this.$refs[formName].validate((valid) => {
					if (!valid) {
						console.log("error submit!!");
						formVerification = false;
					}
				});
				if (!formVerification) {
					return;
				}
				//传值
				let data = new FormData();
				data.append("appid", this.$admin.getAppid());
				data.append("type_id", this.type_id);
				data.append("state", this.ruleForm.state);
				data.append("title", this.ruleForm.title);
				data.append("describe", this.ruleForm.describe);
				data.append("imgages_a", this.ruleForm.imgages_a);
				data.append("imgages_b", this.ruleForm.imgages_b);
				data.append("detailed", this.ruleForm.detailed);
				data.append("connect", this.ruleForm.connect);
				this.$admin
					.postAPI(
						`data/navigation/?`,
						data
					)
					.then((res) => {
						let data = res.data;
						if (data.code == 200) {
							this.$Message.success("操作成功");
						}
						console.log(data);
					});
				//关闭弹窗
				this.dialogVisible = false;
			},
			//修改
			handleEdit(formName) {
				var formVerification = true;
				this.$refs[formName].validate((valid) => {
					if (!valid) {
						console.log("error submit!!");
						formVerification = false;
					}
				});
				if (!formVerification) {
					return;
				}
				//传值
				let data = new FormData();
				//data.append('id', this.ruleForm.id)
				data.append("state", this.ruleForm.state);
				data.append("title", this.ruleForm.title);
				data.append("describe", this.ruleForm.describe);
				data.append("imgages_a", this.ruleForm.imgages_a);
				data.append("imgages_b", this.ruleForm.imgages_b);
				data.append("detailed", this.ruleForm.detailed);
				data.append("connect", this.ruleForm.connect);
				this.$admin
					.postAPI(
						`data/navigation/` + this.ruleForm.id + `?type_id=` + this.type_id,
						data
					)
					.then((res) => {
						let data = res.data;
						if (data.code == 200) {
							this.$Message.success("操作成功");
						}
						console.log(data);
					});
				//关闭弹窗
				this.dialogVisible = false;
			},
			//查看
			seeSel(key, index, row) {
				this.odb.handleKEY = key;
				this.ruleForm = Object.assign({}, row);
				this.seeVisible = true;
			},
			seeClose(done) {
				this.seeVisible = false;
			},
			//查询
			handleSel(key, index, row) {
				//清除表单
				//赋值表单，状态，添加，修改
				this.odb.handleKEY = key;
				this.ruleForm = Object.assign({}, row);
				//打开弹窗
				this.dialogVisible = true;
				if (key == 1) {
					//属于添加
					return
				}
				//属于修改
				//赋值
				this.ruleForm.id = row.id;
				this.ruleForm.state = row.state;
				this.ruleForm.title = row.title;
				this.ruleForm.describe = row.describe;
				this.ruleForm.imgages_a = row.imgages_a;
				this.ruleForm.imgages_b = row.imgages_b;
				this.ruleForm.detailed = row.detailed;
				this.ruleForm.connect = row.connect;
				console.log(row);
				console.log(index);
			},
			//删除
			handleDelete(index, row) {
				console.log(index, row);
			},
			//加载数据列表类
			getList(page) {
				this.$admin
					.getAPI(
						`data/navigation/?type_id=` + this.type_id + `&page=` + page, {}
					)
					.then((res) => {
						let data = res.data;
						this.lists = data.data;
						this.count = data.count;
						console.log(data);
					});
			},
			//分页加载
			handleSizeChange(e) {
				this.getList(e);
			},
			//状态转换
			dateState(row, column) {
				const data = row[column.property];
				for (var i = 0; i < this.options.length; i++) {
					if (this.options[i].value == data) {
						return this.options[i].label;
					}
				}
				return "未知状态";
			},
			//订单转换
			dateLogistics(row, column) {
				const data = row[column.property];
				for (var i = 0; i < this.Logistics.length; i++) {
					if (this.Logistics[i].value == data) {
						return this.Logistics[i].label;
					}
				}
				return "未知状态";
			},
			//时间格式转换
			dateForma(row, column) {
				const timestamp = row[column.property];
				var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? "0" + MM : MM;
				let d = date.getDate();
				d = d < 10 ? "0" + d : d;
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				let s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
			},
		},
		mounted() {
			//默认加载
			if (this.$route.query.type_id != undefined) {
				this.type_id = this.$route.query.type_id;
			}
			this.getList(1);
		},
	};
</script>

<style>
	.row .col-md-6 {
		padding-bottom: 25px;
	}

	.w-100 {
		padding-left: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/admin/body/navigation.vue